

    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {IconRegistry} from "@/lib/IconRegistry";

    @Component({})
    export default class GuaranteeDescription extends Vue {
        @Prop() public guarantee: any;

      public hasIcon(iconName: string) {
        return !!(IconRegistry.getIcon('guarantee', iconName));
      }

        public getIcon(iconName: string){
            return '/static/' + IconRegistry.getIcon('guarantee', iconName);
        }
    }

